<template>

<div>

  <h1 class="text-4xl mt-6 font-valorant">Help and Guides</h1>

     <ul class="flex justify-center w-full m-auto font-valorant mt-4 md:w-5/6 lg:w-3/4">
  <li class="flex-1 mr-1">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500" to="/choosingaccounts">Choosing the right Account to buy</router-link>
  </li>
  <!-- <li class="flex-1 mr-1">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500" to="/sellingaccounts">How to MAke vAluAble Accounts to sell</router-link>
  </li> -->
  <li class="flex-1 mr-1">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white text-red-500" to="/contact">Frequently Asked Questions & ContAct Info</router-link>
  </li>  
</ul>     
</div>


   

</template>

<script>


export default {
  name: 'BuySellContact',
  data () {
    return {

    }
  },
 beforeMount(){

 },    
}
</script>
</script>


// WEBPACK FOOTER //
// src/components/BuySellContact.vue